// extracted by mini-css-extract-plugin
module.exports = {"wrap":"e_Bv","pin":"e_Cv","tip":"e_Dv","wrapOpen":"e_Ev"};